module.exports = __webpack_public_path__ + "static/media/apple_misc.45c48993.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/apple/apple_misc.png
// module id = 1132
// module chunks = 0